import { Button, IconButton, styled } from '@innowise-group/mui-kit';

export const RowTools = styled.div`
  display: flex;
  align-items: center;
  align-self: start;
  gap: 0.75rem;
  min-height: 2.75rem;
  margin-top: 10px;
`;

export const RemoveButton = styled(IconButton)`
  &.MuiIconButton-root {
    padding: 0;
  }

  & svg {
    fill: ${({ theme }) => theme.palette.general.smart};
    transition: fill 0.2s;
  }

  &:hover svg {
    fill: ${({ theme }) => theme.palette.state.error.default};
  }
`;

export const AddButton = styled(Button)`
  &.MuiButton-root {
    margin-left: auto;
  }
`;
